import styled from 'styled-components'

const Menu = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 2.4rem;
  @media (max-width: 768px) {
    margin-left: 2rem;
    margin-right: 2rem;
    padding: 1rem;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: thin;
    scrollbar-color: #ccc transparent;
    gap: 15px;
    &::-webkit-scrollbar {
      height: 6px;
    }
    &::-webkit-scrollbar-thumb {
      background: #ccc;
      border-radius: 10px;
    }
  }
`

Menu.List = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`

Menu.Item = styled.li`
  list-style: none;
  font-size: 1.6rem;
`

export { Menu }
